import { render, staticRenderFns } from "./MapLegendBasicGroups.vue?vue&type=template&id=8acdb03c&"
import script from "./MapLegendBasicGroups.vue?vue&type=script&lang=js&"
export * from "./MapLegendBasicGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports